import { ShimmerThumbnail, ShimmerTitle } from 'react-shimmer-effects';
import { Button } from '../../../../../../common/_custom';
import styles from './KeyOfficialsCreditSummary.module.scss';
import { useAppSelector } from '../../../../../../app/hooks';
import SideDrawer from '../../../../../../common/_custom/SideDrawer/SideDrawer';
import { useEffect, useMemo, useState } from 'react';
import UploadData from '../../../../../Company/UploadData/UploadData';
import { USER_TYPE } from '../../../../../../utils/constants/user';
import { toast } from 'react-toastify';
import { COMBINED_REPORT, DETAILED_REPORT } from '../../CreditBureau';
import clsx from 'clsx';
import { Mixpanel } from '../../../../../../utils/mixpanel';
import {
    INVESTOR_CB_ADD_OFFICIAL,
    INVESTOR_CB_OPEN_COMBINED_REPORT,
    INVESTOR_CB_OPEN_FULL_REPORT,
    INVESTOR_DOWNLOAD_CIBIL_QUERY,
} from '../../../../../../utils/constants/mixpanelEvents/investorEvents';
import { downloadCibilNeedInfoSheet, downloadTransUnionBundle } from '../../../../../../store/dashboard/creditBureau/service';
import { capitalizeWords, isLenderType } from '../../../../../../utils/utils';
import {
    ctaPurpleRight,
    downloadIconDataRoomHovered,
    uploadCibil,
    uploadEquifax,
    creditBureauEmptyState,
} from '../../../../../../assets/hostedassets';
import LoadingSpinner from '../../../../../../common/_custom/LoadingSpinner/LoadingSpinner';
import CreditProgessBar from './Components/CreditProgessBar';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { fetchDirectorBureauCibil, fetchDirectorsOverview } from '../../../../../../store/dashboard/creditBureau/actions';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import CategorySelector from '../../../../../../common/CategorySelector/CategorySelector';
import { set, update } from 'lodash';
import { updateQueryParams } from '../../../../../../utils/searchParamUtils';
import greyLock from '../../../../../../assets/grey-lock.svg';
import Tooltip from '../../../../../../common/_custom/Tooltip/Tooltip';
import { infoToolTip } from '../../../../../../assets/hostedassets';
import { BureauType, NEW_TO_CREDIT_THRESHOLD } from '../Report/CreditBureauConstants';
import AicaOverview from '../../../../../../common/AicaOverview/AicaOverview';

dayjs.extend(relativeTime);

interface TabsToDisplay {
    name: string;
    displayName: string;
    isDefault: boolean;
}

function KeyOfficialsCreditSummary({
    showReport,
    listDirectorsOverview,
    setSelectedReport,
    isLoading,
    assesseeOrgId,
    orgName,
    selectedCompany,
    creditBureauConfig,
}) {
    const [showUploader, setShowUploader] = useState(false);
    const [downloadingCibilQuery, setDownloadingCibilQuery] = useState(false);
    const user = useAppSelector((state) => state.user);
    const isLender = isLenderType();
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const selectedBureauType = searchParams.get('bureauType');
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [selectedBureau, setSelectedBureau] = useState('');

    const isNewToCredit = (cibilScore: number | undefined): boolean => {
        return cibilScore !== undefined && cibilScore < NEW_TO_CREDIT_THRESHOLD;
    };
    // const BUREAU_TYPE = [
    //     {
    //         id: 'All',
    //         label: 'ALL',
    //         isDefault: true,
    //         logoUrl:  "https://logo-url-link",
    //     },
    //     {
    //         id: 'EXPERIAN',
    //         label: 'EXPERIAN',
    //         isDefault: true,
    //         logoUrl:  "https://logo-url-link",
    //     },
    //     {
    //         id: 'EQUIFAX',
    //         label: 'EQUIFAX',
    //         isDefault: true,
    //         logoUrl:  "https://logo-url-link",
    //     },
    // ];

    const getBureauTypes = (creditBureauConfig) =>
        Object.values(creditBureauConfig?.tabsToDisplay)
            .filter((config: any) => config.isActive)
            .map((item: any) => ({
                id: item?.name,
                label: item?.displayName,
                isDefault: item.isDefault,
                logoUrl: item.logoUrl,
            })) || [];

    const BUREAU_TYPES = getBureauTypes(creditBureauConfig);
    const defaultBureauObj = BUREAU_TYPES.find((item: any) => item.isDefault);

    useEffect(() => {
        const bureauType = searchParams.get('bureauType');
        // If 'bureauType' is null, undefined, or an empty string, set it to 'All'
        if (!bureauType) {
            const defaultBureau = defaultBureauObj?.id;

            setSelectedBureau(defaultBureau);
            searchParams.set('bureauType', defaultBureau);
        } else {
            setSelectedBureau(bureauType);
        }
        // Update query params
        updateQueryParams(searchParams, setSearchParams, {}, location);
    }, [searchParams]);

    if (isLoading)
        return (
            <div className={styles.KeyOfficialsCreditSummary} style={{ padding: '12px 24px' }}>
                <ShimmerTitle line={1} gap={20} variant="primary" />
                <ShimmerThumbnail height={320} rounded className={styles.ShimmerThumbnail} />
            </div>
        );

    function getImageSource(director) {
        if (!director?.directorId) return undefined;
        return creditBureauConfig?.tabsToDisplay[director.creditBureau]?.logoUrl;
    }

    const changeSelectedCategory = (categoryId) => {
        setSelectedBureau(categoryId);
        updateQueryParams(searchParams, setSearchParams, { bureauType: categoryId }, location);
    };

    const getImageStyle = (creditBureauType) => {
        if (!creditBureauType) return undefined;
        return creditBureauConfig?.tabsToDisplay[creditBureauType]?.styles?.logoStyles;
    };

    return (
        <>
            <div className={styles.KeyOfficialsCreditSummary}>
                <div className={styles.Content}>
                    <div className={styles.MainHeader}>
                        <div className={styles.LeftHeader}>
                            <div className={clsx(styles.Header, { [styles.withDivider]: BUREAU_TYPES?.length > 1 })}>Director Bureau</div>
                            {BUREAU_TYPES?.length > 1 && (
                                <div className={styles.CategorySelector}>
                                    <CategorySelector
                                        categoryOptions={BUREAU_TYPES}
                                        selectedCategory={selectedBureau}
                                        changeSelectedTab={changeSelectedCategory}
                                    />
                                </div>
                            )}
                        </div>
                        <div className={styles.BarRow}>
                            {/* <Button
                                variant="purpleinverted"
                                onClick={() => {
                                    Mixpanel.track(INVESTOR_CB_OPEN_COMBINED_REPORT);
                                    if (
                                        Array.isArray(listDirectorsOverview) &&
                                        listDirectorsOverview?.length > 0
                                    ) {
                                        showReport(COMBINED_REPORT);
                                    } else
                                        toast.error(
                                            'Please add officials by uploading Director CIBIL in Add New Officials',
                                        );
                                }}
                                text="Combined Director Report"
                                fit
                                style={{ marginTop: '0', fontWeight: '700' }}
                                size="small"
                            /> */}

                            {/* <Button
                                variant="purpleinverted"
                                onClick={async () => {
                                    setDownloadingCibilQuery(true);
                                    Mixpanel.track(INVESTOR_DOWNLOAD_CIBIL_QUERY);
                                    if (
                                        Array.isArray(listDirectorsOverview) &&
                                        listDirectorsOverview?.length > 0
                                    ) {
                                        const payLoad = {
                                            assesseeId: assesseeOrgId,
                                            requestId: Date.now(),
                                            name: orgName,
                                        };
                                        await downloadCibilNeedInfoSheet(payLoad);
                                        setDownloadingCibilQuery(false);
                                    } else {
                                        setDownloadingCibilQuery(false);
                                        toast.error(
                                            'Please add officials by uploading Director CIBIL in Add New Officials',
                                        );
                                    }
                                }}
                                text="Download Bureau Query"
                                fit
                                style={{ marginTop: '0', fontWeight: '700' }}
                                size="small"
                                loading={downloadingCibilQuery}
                            /> */}
                            <div className={styles.HeaderButtons}>
                                {searchParams.get('bureauType') !== BureauType.ALL && (
                                    <>
                                        <div
                                            onClick={() => {
                                                Mixpanel.track(INVESTOR_CB_OPEN_COMBINED_REPORT);
                                                if (
                                                    Array.isArray(listDirectorsOverview) &&
                                                    listDirectorsOverview.some((director) => director.directorId)
                                                ) {
                                                    showReport(COMBINED_REPORT);
                                                } else toast.error('Please add officials by uploading Director CIBIL in Add New Officials');
                                            }}
                                            style={{ marginTop: '0', fontWeight: '700' }}
                                        >
                                            <img src={ctaPurpleRight} alt="" />
                                            Combined Director Report
                                        </div>

                                        <div
                                            onClick={async () => {
                                                if (downloadingCibilQuery) return;
                                                setDownloadingCibilQuery(true);
                                                const bureauType = searchParams.get('bureauType') ?? BureauType.ALL;
                                                const fileName = `Bureau_Query_${orgName}.xlsx`;
                                                Mixpanel.track(INVESTOR_DOWNLOAD_CIBIL_QUERY, {
                                                    userEmail: user?.userData?.primaryEmail,
                                                    fileName,
                                                    bureauType,
                                                });
                                                if (
                                                    Array.isArray(listDirectorsOverview) &&
                                                    listDirectorsOverview.some((director) => director.directorId)
                                                ) {
                                                    if (bureauType === BureauType.TRANSUNION) {
                                                        // TransUnion ships rendered PDFs alongside the Excel sheet —
                                                        // ZIP bundle (Excel + per-director PDFs) is built by aica.
                                                        await downloadTransUnionBundle(assesseeOrgId, orgName);
                                                    } else {
                                                        // Equifax / Experian / All: Excel "Need Info Query" sheet only.
                                                        const payLoad = {
                                                            assesseeId: assesseeOrgId,
                                                            requestId: Date.now(),
                                                            name: orgName,
                                                            ...(bureauType !== BureauType.ALL && {
                                                                type: bureauType,
                                                            }),
                                                        };
                                                        await downloadCibilNeedInfoSheet(payLoad);
                                                    }
                                                    setDownloadingCibilQuery(false);
                                                } else {
                                                    setDownloadingCibilQuery(false);
                                                    toast.error('Please add officials by uploading Director CIBIL in Add New Officials');
                                                }
                                            }}
                                            style={{
                                                marginTop: '0',
                                                fontWeight: '700',
                                                pointerEvents: downloadingCibilQuery ? 'none' : 'auto',
                                                opacity: downloadingCibilQuery ? 0.6 : 1,
                                                cursor: downloadingCibilQuery ? 'not-allowed' : 'pointer',
                                            }}
                                        >
                                            {downloadingCibilQuery ? (
                                                <LoadingSpinner color="purple" height="15px" />
                                            ) : (
                                                <img src={downloadIconDataRoomHovered} alt="" />
                                            )}
                                            Download Bureau Query
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    <hr className={styles.HorizontalLine} />
                    <AicaOverview style={{ marginBottom: '0.5rem' }} module={searchParams.get('selectedTab') ?? ''} />
                    <div className={styles.OverviewContainer}>
                        <div className={styles.Overview}>
                            <div className={styles.Headers}>
                                <div style={{ paddingBottom: '1.188rem' }}>Name</div>
                                {/* <div>All Accounts</div> */}
                                <div style={{ paddingBottom: '1.188rem' }}>DPD Accounts</div>
                                <div style={{ paddingBottom: '1.188rem' }}>Overdue</div>
                                <div style={{ paddingBottom: '1.188rem' }}>Max DPD</div>
                                <div style={{ display: 'flex', paddingBottom: '16px' }}>
                                    Enquiries (90D)
                                    <Tooltip
                                        content={'(Enquiries in last 90 days)'}
                                        direction="right"
                                        style={{ top: '100%', width: 'fit-content' }}
                                    >
                                        <img src={infoToolTip} height={'16px'} style={{ marginLeft: '4px', cursor: 'pointer' }} />
                                    </Tooltip>
                                </div>
                                <div style={{ paddingBottom: '1.188rem' }}>Bureau Score</div>
                                <div style={{ paddingBottom: '1.188rem' }}>Fetched</div>
                            </div>

                            {listDirectorsOverview?.map((director, i) => (
                                <div
                                    className={styles.Row}
                                    key={director.id || i}
                                    onClick={() => {
                                        if (director?.directorId && (!director.bureauError || director.cibilScore)) {
                                            Mixpanel.track(INVESTOR_CB_OPEN_FULL_REPORT);
                                            showReport(DETAILED_REPORT, director);
                                        } else if (!isLender) {
                                            Mixpanel.track(INVESTOR_CB_ADD_OFFICIAL);
                                            setShowUploader(true);
                                        } else {
                                            toast.error('Access restricted. Please ask the admin to fetch the credit details.');
                                        }
                                    }}
                                >
                                    <div className={styles.Name}>{capitalizeWords(director.name)}</div>

                                    {/* Conditionally render credit data or error message */}
                                    {director?.directorId && (!director.bureauError || director.cibilScore) ? (
                                        <>
                                            <div className={`${styles.Dot} ${director.dpdAccounts == 0 ? styles.Green : styles.Red}`}>
                                                {director.dpdAccounts ?? '-'}
                                            </div>

                                            <div className={`${styles.Dot} ${director.currentOverdue == 0 ? styles.Green : styles.Red}`}>
                                                ₹{director.currentOverdue?.toLocaleString?.('en-IN') || '-'}
                                            </div>
                                            <div className={`${styles.Dot} ${director.maxDpds == 0 ? styles.Green : styles.Red}`}>
                                                {director.maxDpds ?? '-'} days
                                            </div>
                                            <div
                                                className={`${styles.Dot} ${
                                                    director.enquiriesInPast90Days == 0 ? styles.Green : styles.Red
                                                }`}
                                            >
                                                {director.enquiriesInPast90Days ?? '-'} enquiries
                                            </div>

                                            <div className={styles.Cibil}>
                                                {isNewToCredit(director.cibilScore) ? (
                                                    <div className={styles.NewToCreditContainer}>
                                                        <span className={styles.NewToCreditText}>Consumer is new to Credit</span>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div>
                                                            {director.cibilScore ?? '-'}
                                                            <span>/900</span>
                                                        </div>
                                                        <CreditProgessBar
                                                            width={((director.cibilScore ?? 0) / 900) * 100}
                                                            ParentWidth="12.5rem"
                                                        />
                                                        <img
                                                            src={getImageSource(director)}
                                                            alt=""
                                                            className={styles.Image}
                                                            style={getImageStyle(director?.creditBureau)}
                                                        />
                                                    </>
                                                )}
                                            </div>
                                        </>
                                    ) : director.bureauError ? (
                                        <div className={styles.ErrorMessageSpan}>
                                            {(() => {
                                                // Derive the copy from the bureau's dataToDisplay config so the message stays
                                                // honest when the editable-field config changes in mongo (no FE deploy needed).
                                                // Example: EQUIFAX has phoneNo editable → "given Phone Number"; EXPERIAN has pan
                                                // editable → "given PAN"; TU has both → "given PAN and Phone Number".
                                                const FIELD_LABELS: Record<string, string> = { pan: 'PAN', phoneNo: 'Phone Number' };
                                                const dataToDisplay =
                                                    creditBureauConfig?.tabsToDisplay?.[director.creditBureau]?.dataToDisplay ?? {};
                                                const editableFields = Object.entries(dataToDisplay)
                                                    .filter(([, cfg]: [string, any]) => cfg?.isEditable)
                                                    .map(([key]) => FIELD_LABELS[key] ?? key);
                                                const fieldList = editableFields.length ? editableFields.join(' and ') : 'inputs';
                                                return `Consumer not found for given ${fieldList}`;
                                            })()}
                                        </div>
                                    ) : (
                                        <>
                                            <div className={styles.NA}></div>
                                            <div className={styles.NA}></div>
                                            <div className={styles.NA}></div>
                                            <div className={styles.NA}></div>
                                            <div className={styles.NA}></div>
                                        </>
                                    )}

                                    <div className={styles.Fetched} style={{ marginLeft: '15px' }}>
                                        {director?.directorId ? (
                                            <div className={styles.Date}>{dayjs(director?.lastFetched)?.fromNow()}</div>
                                        ) : (
                                            <div
                                                className={styles.FetchNow}
                                                onClick={() => {
                                                    if (isLender) return;
                                                    Mixpanel.track(INVESTOR_CB_ADD_OFFICIAL);
                                                    setShowUploader(true);
                                                }}
                                            >
                                                <img src={ctaPurpleRight} alt="" />
                                                <span className={styles.FetchNowText}>Fetch Now</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}

                            {!isLender &&
                                (listDirectorsOverview?.length === 0 ? (
                                    <div className={clsx(styles.AddOfficialEmptyState)}>
                                        <img src={creditBureauEmptyState} alt="No Directors" className={styles.EmptyStateImage} />
                                        <p className={styles.EmptyStateText}>
                                            No Director added yet?&nbsp;
                                            <span
                                                className={styles.Add}
                                                onClick={() => {
                                                    Mixpanel.track(INVESTOR_CB_ADD_OFFICIAL);
                                                    setShowUploader(true);
                                                }}
                                            >
                                                Add Director
                                            </span>
                                        </p>
                                    </div>
                                ) : (
                                    <div className={clsx(styles.AddOfficial)}>
                                        Any director missing?&nbsp;
                                        <span
                                            className={styles.Add}
                                            onClick={() => {
                                                Mixpanel.track(INVESTOR_CB_ADD_OFFICIAL);
                                                setShowUploader(true);
                                            }}
                                        >
                                            Add Director Or Refresh
                                        </span>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
                {showUploader && (
                    <SideDrawer
                        onClose={() => {
                            setShowUploader(false);
                            const payload = {
                                orgId: selectedCompany.assesseeOrgId,
                                reportId: selectedCompany.reportId || '',
                                type: selectedBureauType && selectedBureauType !== BureauType.ALL ? selectedBureauType : null,
                            };
                            if (selectedBureauType === 'CIBIL') {
                                dispatch(fetchDirectorBureauCibil(payload));
                            } else {
                                dispatch(fetchDirectorsOverview(payload));
                            }
                        }}
                        width="50%"
                    >
                        <SideDrawer.Header>
                            Bureau Details for Directors
                            <span className={styles.Grey}> | {selectedCompany?.orgName}</span>
                        </SideDrawer.Header>
                        <UploadData
                            overrideSelectedStep={'creditBureau'}
                            userType={USER_TYPE.INVESTOR}
                            isInvestor
                            assesseeOrgId={assesseeOrgId}
                            closeDrawer={() => {
                                const payload = {
                                    orgId: selectedCompany.assesseeOrgId,
                                    reportId: selectedCompany.reportId || '',
                                    type: selectedBureauType && selectedBureauType !== BureauType.ALL ? selectedBureauType : null,
                                };
                                if (selectedBureauType === 'CIBIL') {
                                    dispatch(fetchDirectorBureauCibil(payload));
                                } else {
                                    dispatch(fetchDirectorsOverview(payload));
                                }
                                setShowUploader(false);
                            }}
                        />
                        {/* <SideDrawer.Footer>
                            <div className={styles.FooterText}>
                                <img src={greyLock} alt="lock" height="10px" />
                                256-Bit Bank-Level Encryption
                            </div>
                        </SideDrawer.Footer> */}
                    </SideDrawer>
                )}
            </div>
            {/* <div
                style={{ background: 'transparent', marginTop: '-1rem', padding: 0 }}
                className={styles.KeyOfficialsCreditSummary}
            >
                <ChargesTable />
            </div> */}
        </>
    );
}

export default KeyOfficialsCreditSummary;
